import type { Squad } from '../../../types';

type AssignmentSnapshot = Pick<Squad, 'sessionPlan' | 'schedule'>;

/** Firestore map ordering is not significant; lesson array ordering is. */
function canonical(value: unknown): unknown {
  if (Array.isArray(value)) return value.map(canonical);
  if (value && typeof value === 'object') {
    return Object.fromEntries(Object.entries(value)
      .filter(([, item]) => item !== undefined)
      .sort(([a], [b]) => a.localeCompare(b))
      .map(([key, item]) => [key, canonical(item)]));
  }
  return value;
}

function planContent(plan: Squad['sessionPlan']) {
  // updatedAt records a write, not a change to lesson assignments.
  return plan ? { curriculumId: plan.curriculumId, slots: plan.slots } : null;
}

export function hasCurriculumPlanConflict(latest: AssignmentSnapshot, baseline: AssignmentSnapshot | null): boolean {
  if (!baseline) return true;
  return JSON.stringify(canonical(planContent(latest.sessionPlan))) !== JSON.stringify(canonical(planContent(baseline.sessionPlan)))
    || JSON.stringify(canonical(latest.schedule || null)) !== JSON.stringify(canonical(baseline.schedule || null));
}
